var isBrowser = typeof document !== "undefined";
export { isBrowser };